(function() {
  const cookieKey = 'shopify_auto_currency_done';

  // Only run once per user
  if (document.cookie.split('; ').find(row => row.trim().startsWith(cookieKey + '='))) {
    console.log("Currency script skipped – cookie flag already set.");
    return;
  }

  console.log("AutoCurrency: starting geolocation...");

  // Use Shopify's browsing context API for better accuracy
  fetch(window.Shopify.routes.root + 'browsing_context_suggestions.json?country[enabled]=true')
    .then(res => res.json())
    .then(data => {

      const detected = data.detected_values?.country?.handle;
      console.log("AutoCurrency: detected country:", detected);

      if (!detected) {
        console.warn("AutoCurrency: no country detected — aborting.");
        setCookie();
        return;
      }

      // Eurozone list + Lebanon for testing
      const euroCountries = [
        'AT','BE','CY','EE','FI','FR','DE','GR','IE','IT',
        'LV','LT','LU','MT','NL','PT','SK','SI','ES'
      ];

      // Other explicit currency map (edit/remove as needed)
      const currencyMap = {
        'AE': 'AED', // UAE
        'US': 'USD', // United States
        'CA': 'CAD', // Canada
        'JO': 'JOD', // Jordan
        'KW': 'KWD', // Kuwait
        'IQ': 'IQD', // Iraq
        'SA': 'SAR', // Saudi Arabia
      };

      let targetCurrency = null;

      // Determine target currency
      if (euroCountries.includes(detected)) {
        targetCurrency = 'EUR';
        console.log(`AutoCurrency: ${detected} is in euroCountries → switching to EUR`);
      } else if (currencyMap[detected]) {
        targetCurrency = currencyMap[detected];
        console.log(`AutoCurrency: mapped ${detected} → switching to ${targetCurrency}`);
      } else {
        console.log(`AutoCurrency: no mapping for ${detected} — no currency change.`);
      }

      if (!targetCurrency) {
        setCookie();
        return;
      }

      const currentCurrency = window.Shopify && Shopify.currency ? Shopify.currency.active : null;
      console.log("AutoCurrency: current currency:", currentCurrency);

      // Only perform the change if the current currency is different from the target currency
      if (currentCurrency !== targetCurrency) {
        console.log(`AutoCurrency: changing currency to ${targetCurrency}`);

        // 1. Modify the URL by adding the currency query parameter
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set('currency', targetCurrency);

        // 2. Redirect to the new URL with the currency parameter
        window.location.href = currentUrl.toString();
        console.log(`AutoCurrency: redirecting to ${currentUrl.toString()}`);
      } else {
        console.log("AutoCurrency: currency already correct — no change.");
      }

      setCookie();

    })
    .catch(error => {
      console.error("AutoCurrency: error detecting geolocation:", error);
      setCookie();
    });

  function setCookie() {
    document.cookie = `${cookieKey}=1; max-age=31536000; path=/`;
    console.log("AutoCurrency: cookie set to prevent reruns.");
  }

})();
